import {
  Component,
  ChangeDetectionStrategy,
  OnInit,
  Input,
  ElementRef,
  Output,
  EventEmitter,
  ViewChild
} from '@angular/core';
import { ProductType, PRODUCT_TYPES } from '@apps/api-interfaces';
import { setTheme } from '@apps/tools';

const getPathname = (): ProductType => {
  let url = window.location.pathname;
  if (url.indexOf('?') > -1) {
    url = url.substring(0, url.indexOf('?'));
  }

  const all = PRODUCT_TYPES.map(e => e.id);
  const path = url.split('/');

  if (all.includes(path && path[1])) {
    return path[1] as ProductType;
  }

  if (all.includes(path && path[2])) {
    return path[2] as ProductType;
  }

  return all[2] as ProductType;
};

const getDomain = (): string => {
  return 'https://zatrzymajlicznik.pl';
};

@Component({
  selector: 'scw-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent implements OnInit {
  @Input() cid: string;
  @Input() zipCode: ProductType;
  @Input() href: string;
  @Input() small: string;
  @Input() buttonText: string;
  @Input() product: ProductType = getPathname();
  @Input() domain: string = getDomain();
  @Input() maxWidth: string;
  @Input() type = 0; // WidgetType
  @Input() ng: boolean;
  
  @ViewChild('wrap', { static: true }) wrap: ElementRef;

  @Output() onproductchanged: EventEmitter<ProductType> = new EventEmitter<ProductType>();
  @Output() onsubmit: EventEmitter<any> = new EventEmitter();

  ngOnInit(): void {
    this.onproductchanged.emit(this.product);
    setTheme(this.product, this.wrap && this.wrap.nativeElement);
  }

  setProduct(type: ProductType) {
    this.product = type;
    this.onproductchanged.emit(type);
    setTheme(type, this.wrap && this.wrap.nativeElement);
  }

  onSubmitForm(event) {
    let data = Object.assign(event, {
      product: this.product
    });

    if (this.cid) {
      if (this.cid !== 'disabled') {
        data = Object.assign(data, {
          cid: this.cid
        });
      }
    }

    if (this.ng) {
      this.onsubmit.emit(data);
    } else {
      const params = new URLSearchParams(data).toString();
      window.location.href = `${this.domain}/porownywarka/${ this.product }/kalkulator/porownanie?${ params }`;
    }
  }

  prepareExternalLinks(url: string, event: Event) {
    if (event) event.preventDefault();

    let data = { url };

    if (this.cid && this.domain) {
      data = Object.assign(data, {
        cid: this.cid
      });
      const b64 = btoa(JSON.stringify(data));
      window.location.href = `${this.domain}/e/${b64}`;
      return;
    }

    this.onsubmit.emit(data);
  }
}
